import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Grid,
  Box
} from '@mui/material';
import axios from 'axios';

const dummyUsers = [
  { id: 1, name: 'John Manager' },
  { id: 2, name: 'Lisa Supervisor' }
];

const weekDays = [
  'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'
];

export default function AddTaskDialog({ showTaskModal, setShowTaskModal, saveTask, currentTask=null }) {
  const [form, setForm] = useState(currentTask ? currentTask : {
    title: '',
    description: '',
    assigned_to: null,
    frequency: 'daily',
    day_of_week: '',
    day_of_month: ''
  });
  // console.log(form)
  const [users, setUsers] = useState([])
const url=process.env.REACT_APP_SERVER_URL;
useEffect(() => {
    getAllUsers();
    }, []);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };
  const getAllUsers = async() =>{
      try{
          const response  = await axios.get(`${url}/users`);
          if(response && response.data){
              setUsers(response.data);
          }
  
      }
      catch(error){
          console.log(error);
      }
    }

  const handleSave = () => {
    // onSave(form);
    onClose();
    setForm({
      title: '',
      description: '',
      assigned_to: '',
      frequency: 'daily',
      day_of_week: '',
      day_of_month: ''
    });
  };

  const renderExtraFields = () => {
    if (form.frequency === 'weekly') {
      return (
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth>
            <InputLabel>Day of Week</InputLabel>
            <Select
              name="day_of_week"
              value={form.day_of_week}
              onChange={handleChange}
              label="Day of Week"
            >
              {weekDays.map(day => (
                <MenuItem key={day} value={day}>
                  {day}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      );
    }

    if (form.frequency === 'monthly') {
      return (
        <Grid item xs={12} sm={6}>
          <TextField
            name="day_of_month"
            label="Day of Month"
            type="number"
            inputProps={{ min: 1, max: 31 }}
            value={form.day_of_month}
            onChange={handleChange}
            fullWidth
          />
        </Grid>
      );
    }

    return null;
  };
  function onClose(){
    setShowTaskModal(false);
  }

  return (
    <Dialog open={showTaskModal} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Add New Task</DialogTitle>
      <DialogContent>
        <Box mt={1}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                label="Task Title"
                name="title"
                fullWidth
                value={form.title}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Description"
                name="description"
                fullWidth
                multiline
                minRows={2}
                value={form.description}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Assign To</InputLabel>
                <Select
                  name="assigned_to"
                  value={form.assigned_to}
                  onChange={handleChange}
                  label="Assign To"
                >
                  {users.map(user => (
                    <MenuItem key={user.id} value={user.id}>
                      {user.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>frequency</InputLabel>
                <Select
                  name="frequency"
                  value={form.frequency}
                  onChange={handleChange}
                  label="frequency"
                >
                  <MenuItem value="daily">Daily</MenuItem>
                  <MenuItem value="weekly">Weekly</MenuItem>
                  <MenuItem value="monthly">Monthly</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            {renderExtraFields()}
          </Grid>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="inherit">Cancel</Button>
        <Button onClick={(e)=>{
          saveTask(form);
          setShowTaskModal(false);
          }} variant="contained">Save Task</Button>
      </DialogActions>
    </Dialog>
  );
}
